import React, { PropsWithChildren, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, SxProps, Theme } from '@mui/material';
import Menu from '@mui/material/Menu';

type Props = PropsWithChildren<{
  sx?: SxProps<Theme>;
}>;

export const HeaderMobileMenu = ({ children, sx }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        sx={[{ color: '#ffffff' }, ...(Array.isArray(sx) ? sx : [sx])]}
        aria-label="menu button"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        <MenuIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {children}
      </Menu>
    </>
  );
};
